import {
    PANEL_LEFT_SHOW_HIDE_CLICK,
    PANEL_RIGHT_RECORD_DETAILS_SHOW_HIDE_CLICK
} from '../actions';


export const toggleLeftSidePanel = () => (
        {
            type: PANEL_LEFT_SHOW_HIDE_CLICK,
            payload: {}
        }
    )

export const toggleRecordDetailsPanel = (isShow) => ({
      type: PANEL_RIGHT_RECORD_DETAILS_SHOW_HIDE_CLICK,
      payload: {isShow},
    });

